import { BuildingSelectFormikField } from '../../Building'
import { FieldStackedLabel } from '../../Field'

import { DOC_FLOW_BUILDING_FIELD_NAME } from './DocFlowBuildingField.constants'

function DocFlowBuildingField({
  inputInfo,
  inputLabel,
  name = DOC_FLOW_BUILDING_FIELD_NAME,
  placeholder,
  ...restProps
}) {
  return (
    <BuildingSelectFormikField
      {...restProps}
      Field={FieldStackedLabel}
      controlProps={{
        contentProps: {
          inputProps: {
            placeholder,
          },
        },
      }}
      emptyValue={null}
      fieldComponentProps={{
        info: inputInfo,
        label: inputLabel,
      }}
      name={name}
    />
  )
}

export default DocFlowBuildingField
